import { __decorate, __param } from '../../../../../node_modules/tslib/tslib.es6.js';
import { request } from '../../../base/parts/request/browser/request.js';
import { IConfigurationService } from 'monaco-editor/esm/vs/platform/configuration/common/configuration.js';
import { ILoggerService } from 'monaco-editor/esm/vs/platform/log/common/log.js';
import { AbstractRequestService } from '../common/request.js';
let RequestService = class RequestService extends AbstractRequestService {
    constructor(configurationService, loggerService) {
        super(false, loggerService);
        this.configurationService = configurationService;
    }
    async request(options, token) {
        if (!options.proxyAuthorization) {
            options.proxyAuthorization = this.configurationService.getValue('http.proxyAuthorization');
        }
        return this.logAndRequest('browser', options, () => request(options, token));
    }
    async resolveProxy(url) {
        return undefined;
    }
};
RequestService = ( __decorate([
    ( __param(0, IConfigurationService)),
    ( __param(1, ILoggerService))
], RequestService));
export { RequestService };
